import { MelwaysProvider } from '@seek/melways-react';
import { hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';

import App from './App/App';
import type { Environment } from './App/services/environment';
import type { EmployerSiteName } from './types';

type ClientContext = {
  language: string;
  site: EmployerSiteName;
  environment: Environment;
};

export const getBuildVersion = () =>
  window.__CONFIG__?.buildNumber ?? 'Unknown';
const getBranchName = () => window.__CONFIG__?.branchName ?? 'Unknown';

export default ({ site, environment, language }: ClientContext) => {
  const app = document.getElementById('app');
  if (!app) {
    throw new Error('Could not find app');
  }
  hydrateRoot(
    app,
    <MelwaysProvider.Client site={site}>
      <BrowserRouter>
        <App
          branchName={getBranchName()}
          buildVersion={getBuildVersion()}
          environment={environment}
          language={language}
          site={site}
        />
      </BrowserRouter>
    </MelwaysProvider.Client>,
  );
};

export type { ClientContext };
